import { Store, compose, createStore } from 'redux';
import { IArgosStore } from '../interfaces';
import { rootReducer } from '../reducers/index';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { applyMiddleware } from 'redux';
import { IHistory } from 'src/interfaces';
import { getUserData, checkForUserExpiry } from '../services/loginService';
import { fromJS } from 'immutable';
declare var require: any;
const objectAssign = require('object-assign');

export function configureStore(initialState = {}): Store<IArgosStore> {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const userData = localStorage.getItem('EnviroConnectUserInfo');
    const login = fromJS(JSON.parse(userData));
    if (checkForUserExpiry(JSON.parse(userData))) {
        return;
    }
    let store = createStore(
        rootReducer,
        objectAssign(initialState, login ? { login } : {}),
        composeEnhancers(
            applyMiddleware(...getMiddlewares())
        )
    );
    return store;
}

function getMiddlewares() {
    let middlewares = [
        thunk,
        promiseMiddleware()
    ];
    return middlewares;
}

export const store = configureStore();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/index.tsx